// 統一 protobufjs Root — 載入後端權威 Gateway/Common 信封多檔（複製自姊妹專案 pixi_slot 的
// 後端權威 .proto，2026-06-15 版）＋本專案還原的 Slot026 遊戲專屬 SlotDef.proto。
// 以 Vite `?raw` 取得各 .proto 文字後解析進同一個 root；跨檔型別以完整名稱解析，
// 故先移除 import 行並自行注入 google.protobuf.Any（protobufjs 同步 parse 不自動解析 import）。
//
// 注意：信封層 PacketCmd / ResponseInfo 另有 proto/envelope.ts 的獨立最小宣告供 PacketCodec 使用
// （GameServerClient 與其單元測試依賴那份、且已實機驗證）。本 root 載入的 gateway_cmd.proto 雖也含
// PacketCmd / ResponseInfo，但實際只會用到其中的「遊戲階段」訊息（ClientSpinCmd 等）；兩份定義分屬
// 不同的 protobuf.Root，互不影響。
//
// keepCase 保留欄位原始大小寫（Cmd / TotalBet / type_url …），與後端 proto 原文一致，程式存取才對得上。
import * as protobuf from 'protobufjs'
import commonText from '../../../../proto/common.proto?raw'
import commonCmdText from '../../../../proto/common_cmd.proto?raw'
import slotDefText from '../../../../proto/SlotDef.proto?raw'
import gatewayCmdText from '../../../../proto/gateway_cmd.proto?raw'
import gatewayLoginText from '../../../../proto/gateway_login.proto?raw'
import gatewayGameInfoText from '../../../../proto/gateway_gameinfo.proto?raw'
import gatewayGetBalanceText from '../../../../proto/gateway_getbalance.proto?raw'
import gatewayDeviceInfoText from '../../../../proto/gateway_deviceinfo.proto?raw'

// google.protobuf.Any 的 wire 定義（ClientSpinCmd.SpinData 使用；protobufjs 同步 parse 不含內建 well-known types）。
const ANY_PROTO = `
syntax = "proto3";
package google.protobuf;
message Any { string type_url = 1; bytes value = 2; }
`

// 順序不影響最終解析（resolveAll 統一連結跨檔型別），但仍讓被依賴者（Any/common）排在前面較直覺。
const SOURCES = [
  ANY_PROTO,
  commonText,
  commonCmdText,
  slotDefText,
  gatewayLoginText,
  gatewayGameInfoText,
  gatewayGetBalanceText,
  gatewayDeviceInfoText,
  gatewayCmdText,
]

function stripImports(source: string): string {
  return source.replace(/^[ \t]*import[ \t]+["'][^"']+["'][ \t]*;[ \t]*$/gm, '')
}

let cached: protobuf.Root | null = null

/** 取得（並快取）載入全部 .proto 後的 protobufjs Root。 */
export function protoRoot(): protobuf.Root {
  if (cached === null) {
    const built = new protobuf.Root()
    for (const source of SOURCES) {
      protobuf.parse(stripImports(source), built, { keepCase: true })
    }
    built.resolveAll()
    cached = built
  }
  return cached
}

/** 以完整名稱（含 package）查訊息型別，如 `Gateway.ClientSpinCmd`、`Slot026RedRidingHood.SlotResult`。 */
export function lookupType(fullName: string): protobuf.Type {
  return protoRoot().lookupType(fullName)
}
